import XLogo from '../images/Portfolio2XLogo.png';
import YTLogo from '../images/Portfolio2YTLogo.png';
import LinkedInLogo from '../images/Portfolio2LinkedInLogo.png';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';

function SideMenu() {
    const [menuOut,setmenuOut] = useState(false);

    useEffect(() => {
        console.log(menuOut);
    },[menuOut])

  return (
    <div className = {`sidemenu ${menuOut ? 'sidemenu-out' : ''}`}>
        <div className = {`sidemenu-content`}>
            <div className = "sidemenu-content-content">
                <Link to = "/" className = "sidemenu-content-content-logo">Seth.</Link>
                <div className = "sidemenu-content-content-buttons">
                    <Link to = "/" className = "sidemenu-content-content-buttons-button">HOME</Link>
                    <Link to = "/about"  className = "sidemenu-content-content-buttons-button">ABOUT</Link>
                    <Link to = "/services"  className = "sidemenu-content-content-buttons-button">SERVICES</Link>
                    <Link to = "/works"  className = "sidemenu-content-content-buttons-button">WORKS</Link>
                    <Link to = "/contact"  className = "sidemenu-content-content-buttons-button">CONTACT</Link>
                </div>
                <div className = "sidemenu-content-content-info">
                    <div className = "sidemenu-content-content-info-buttons">
                        <button onClick={() => {window.open('https://twitter.com/SethTML05','_blank');}} className = "sidemenu-content-content-info-buttons-button"><img className = "sidemenu-content-content-info-buttons-button-img" src = {XLogo} /></button>
                        <button onClick={() => {window.open('https://www.youtube.com/@sethtml','_blank');}} className = "sidemenu-content-content-info-buttons-button"><img className = "sidemenu-content-content-info-buttons-button-img" src = {YTLogo} /></button>
                        <button onClick={() => {window.open('https://www.linkedin.com/in/sethlamar/','_blank');}} className = "sidemenu-content-content-info-buttons-button"><img className = "sidemenu-content-content-info-buttons-button-img" src = {LinkedInLogo} /></button>
                    </div>
                    <span className = "sidemenu-content-content-info-copyright">Copyright ©2026 Seth LaMar. All right reserved.</span>
                </div>
            </div>
        </div>
        <button onClick={() => {setmenuOut(!menuOut)}} className = {`sidemenu-hamburger ${menuOut ? 'sidemenu-exit' : ''}`}>X</button>
    </div>
  );
}

export default SideMenu;